<template>
  <div class="appvue">
    <NavBar v-if="showNav" />
    <router-view :class="['content-page', { 'no-shell': !showNav }]" />
    <UpdatePrompt />
  </div>
</template>

<script>
import NavBar from '@/components/navbar/NavBar.vue'
import UpdatePrompt from '@/components/UpdatePrompt.vue'
import { mapState } from 'vuex'

export default {
  components: { NavBar, UpdatePrompt },
  computed: {
    ...mapState(['role']),
    showNav() {
      const hideNavRoutes = [
        /^\/menu$/,
        /^\/login$/,
        /^\/registrarse/,
        /^\/puntos\/ticket\//,
        /^\/solicitar-recuperacion$/,
        /^\/expired-recovery$/,
        /^\/cambiar_pass/,
        /^\/magic-link-login(\/[\w-]+)?$/
      ]
      const currentPath = this.$route.path
      const isRouteHidden = hideNavRoutes.some((regex) => regex.test(currentPath))
      const user = this.$store.state.user
      return !isRouteHidden && this.$route.name !== 'NotFound' && user && user.token
    }
  },
  mounted() {
    const requiresAuth = this.$route.matched.some(record => record.meta.requiresAuth)
    const user = this.$store.state.user
    if (requiresAuth && (!user || !user.token)) this.$router.push('/login')

    const roleToken = this.$store.state.roleToken
    if (roleToken) {
      this.$store.dispatch('fetchRole').then(() => {
        this.$store.dispatch('startRoleAutoRefresh')
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: var(--juliam-sans, Avenir, Helvetica, Arial, sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--juliam-text, #f5f7ff);
  background: var(--juliam-ink, #050813);
}

.content-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  padding-top: 64px;
}
.content-page.no-shell {
  padding-top: 0;
  display: block;
}
.container {
  padding-top: 80px !important;
}

</style>
